// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: shared/api/common/ENUM_AdviserPortalTheme.proto

export enum ENUM_AdviserPortalTheme {
  ADVISER_PORTAL_THEME_UNSPECIFIED = 'ADVISER_PORTAL_THEME_UNSPECIFIED',
  ADVISER_PORTAL_THEME_DASHLY = 'ADVISER_PORTAL_THEME_DASHLY',
  ADVISER_PORTAL_THEME_MAB = 'ADVISER_PORTAL_THEME_MAB',
  UNRECOGNIZED = 'UNRECOGNIZED',
}
